import WRAP from "WRAP-JS";

/* eslint-disable */
WRAP.Geo.Renderer.FIRExt = function() {

  this.draw = function(layer, content, conf, context, style, data, revision, dl) {
    WRAP.Geo.check(layer, content, conf, context, style, data, revision, dl);

    var current_zoom = -1;
    if ( context && context.tiles.length )
      current_zoom = context.zoom;

    var tiled = data._handler().tiled();
    if ( !tiled ) {
      if ( !conf.Attributes.min_zoom ) {
        if ( this.content_revision == revision.content
          &&  this.conf_revision == revision.conf
          &&  this.style_revision == revision.style
          &&  this.data_revision == revision.data )
          return;
      }
      else {
        if ( this.last_zoom == current_zoom
          &&  this.content_revision == revision.content
          &&  this.conf_revision == revision.conf
          &&  this.style_revision == revision.style
          &&  this.data_revision == revision.data )
          return;
      }
    }
    else {
      if ( this.content_revision == revision.content
        &&  this.context_revision == revision.context
        &&  this.conf_revision == revision.conf
        &&  this.style_revision == revision.style
        &&  this.data_revision == revision.data )
        return;
    }

    layer.setStatus({status:"invalid"});

    var gd = data._handler().getData(content, context);
    if ( !gd ) {
      if ( data._handler()._error )
        layer.setStatus({status:"error", reason:data._handler()._error});
      data._handler().loadData(content, context, function() {
        WRAP.Geo.redraw(layer);
      });
      return;
    }

    var features = [];
    for ( var i = 0 ; i < gd.length ; i++ ) {
      var fc = gd[i].features;
      if ( fc ) {
        for ( var j = 0 ; j < fc.length ; j++ )
          features.push(fc[j]);
      }
      else if ( gd[i].type == "Feature" ) {
        features.push(gd[i]);
      }
    }

    layer.clear();

    var getArcPath = function(orgPoint,  start, end, radius, counterClockwise) {
      var path = [];

      //radius(nautical mile)
      var step = 1;
      if ( radius < 270 )
        step = 5;
      else if ( radius < 540 )
        step = 2;

      if (counterClockwise) {
        if (start < end)
          start += 360;
        for ( var r = start ; r > end ; r-=step ) {
          var pos = WRAP.Geo.Util.gcPos(orgPoint[1], orgPoint[0], r, radius);
          path.push([pos.lon, pos.lat]);
        }
      } else {
        if (end < start)
          end += 360;
        for ( var r = start ; r < end ; r+=step ) {
          var pos = WRAP.Geo.Util.gcPos(orgPoint[1], orgPoint[0], r, radius);
          path.push([pos.lon, pos.lat]);
        }
      }

      var pos = WRAP.Geo.Util.gcPos(orgPoint[1], orgPoint[0], end, radius);
      path.push([pos.lon, pos.lat]);
      return path;
    };

    if ( !conf.Attributes.min_zoom || current_zoom >= conf.Attributes.min_zoom ) {

      var style_name = style||"default";

      var render_types = conf.Attributes.features;
      var length = features.length;
      for ( var i = 0 ; i < length ; i++ ) {
        var item = features[i];
        var geometry = item.geometry;
        if ( !geometry )
          continue;
        var prop = item.properties;
        if ( prop && prop.display_flag === false )
          continue;

        var style = null;
        for ( var j = 0 ; j < render_types.length ; j++ ) {
          var selector = render_types[j].selector;
          if ( selector ) {
            if ( selector.type == "key_value" ) {
              if ( prop[selector.key] == selector.value ) {
                style = render_types[j].style;
                break;
              }
            }
          }
          else {
            style = render_types[j].style;
            break;
          }
        }

        var ts = style && style[style_name];
        if ( !ts )
          continue;

        for (var k = 0; k < geometry.coordinates.length; k++) {
          var rhumbline = prop.bdry_rl_idx ? prop.bdry_rl_idx[k] || [] : [];
          var counterClockwise = prop.bdry_cca ? (prop.bdry_cca[k] || []).map(function (o) {return o.idx }) : [];
          var clockwise = prop.bdry_ca ? (prop.bdry_ca[k] || []).map(function (o) { return o.idx}) : [];
          var ccIdx = 0, cIdx= 0;
          var method = [];
          var points = [];
          for (var l = 0; l < geometry.coordinates[k].length; l++) {
            points.push(geometry.coordinates[k][l]);
            if (rhumbline.indexOf(l) >= 0) {
              method.push('RL');
            } else if (counterClockwise.indexOf(l) >= 0) {
              method.push('GC');
              var cca = prop.bdry_cca[k][ccIdx].arc_org;
              var counterArcPath = getArcPath(cca.lonlat, cca.start, cca.end, cca.dist, true);
              counterArcPath.forEach(function (p) {
                points.push(p);
                method.push('GC');
              });
              ccIdx++;
            } else if (clockwise.indexOf(l) >= 0) {
              method.push('GC');
              var ca = prop.bdry_ca[k][cIdx].arc_org;
              var arcPath = getArcPath(ca.lonlat, ca.start, ca.end, ca.dist, false);
              arcPath.forEach(function (p) {
                points.push(p);
                method.push('GC');
              });
              cIdx++;
            } else {
              method.push('GC');
            }
          }
          method.pop();//last method is unnecessary

          if (points.length) {
            var feature = new WRAP.Geo.Feature.GeoLine({
              path: points,
              lineWidth: ts.line_width,
              strokeStyle: ts.line_color,
              fillStyle: ts.fill_color,
              fillImage: ts.fill_image,
              option: ts.option,
              method: method
            });
            feature.geo = item;
            layer.addFeature(feature);
          }
        }
      }
    }

    this.content_revision = revision.content;
    this.context_revision = revision.context;
    this.conf_revision = revision.conf;
    this.style_revision = revision.style;
    this.data_revision = revision.data;
    this.last_zoom = current_zoom;

    layer.setStatus({status:"valid"});
    WRAP.Geo.invalidate();

  };

};
/* eslint-enable */